var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruckSmall = function SvgTruckSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#truck-small_svg__a)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.668 1.25H.418v5.417h6.25V1.25ZM6.668 3.333h1.667l1.25 1.25v2.084H6.668V3.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.292 8.75a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083ZM7.71 8.75a1.042 1.042 0 1 0 0-2.083 1.042 1.042 0 0 0 0 2.083Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "truck-small_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h10v10H0z"
  })))));
};
export default SvgTruckSmall;